import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=21960d52&"
import script from "./Field.vue?vue&type=script&lang=js&"
export * from "./Field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports